<template>
  <div class="fill-height">
      <v-card class="fill-height">
        <v-card-title>
          <v-chip small color="primary">جزئیات حساب</v-chip>
          <v-spacer/>
          <v-btn style="background-color:#be1e0b" dark icon small @click.stop="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-card-title>
        <v-card-text>
          <v-expansion-panels v-if="userType==='user'" flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-col sm="3">
                  <v-chip color="warning" small>درخواست بررسی</v-chip>
                </v-col>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!--                  <v-card flat>-->
                <v-textarea v-model="text" outlined dense>
                </v-textarea>
                <v-card-actions dir="ltr">
                  <v-btn small color="primary" @click="sendRequest">ارسال</v-btn>
                </v-card-actions>
                <!--                  </v-card>-->

              </v-expansion-panel-content>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-card-text>

          <b-table
              v-if="can('accountList')"
              :items="reports"
              :fields="columns"
              stacked="md"
              show-empty
              responsive
              :current-page="skip"
              :per-page=0
              striped
              class="fixed-header-table"
              style="font-size: 15px;color: black"
          >
           <template #cell(remaining)="row">
             <span v-if="row.item.remaining && row.item.remaining<0"
                   style="color: red">{{ formatNumber( row.item.remaining) }}</span>
             <span v-else>
               {{ formatNumber( row.item.remaining) }}</span>
           </template>


          </b-table>

        </v-card-text>
      </v-card>
    </div>
</template>

<script>


import Request_se from "@/views/define/requestUser/Request_se";
import Account_se from "@/views/define/account/Account_se";

export default {

  props: {
    userType: String
  },
  data() {
    return {
      text: '',
      reports:[],
      showAll: false,
      eId:'',
      totalSize:null ,
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        { key: 'date', label: 'تاریخ' },
        { key: 'article', label: 'شرح پرداخت' },
        {
          key: 'debtor',
          label: 'بدهکار (ریال)',
          formatter: this.formatNumber
        },
        {
          key: 'creditor',
          label: 'بستانکار (ریال)',
          formatter:  this.formatNumber
        },
        {
          key: 'remaining',
          label: 'مانده (ریال)',
          formatter:  this.formatNumber
        }
      ]
    }
  },

created() {
  this.eId=this.$route.query.id
  this.getDetails()
},
  methods: {
    formatNumber(value){
      return Number(value || 0).toLocaleString('fa-IR');
    },
    getDetails() {
      Account_se.detailsOfPanel(this.eId, this.skip - 1, this.take).then(response => {
        this.reports = response.data.reports
        this.totalSize = response.data.totalSize
      })

    },

    pageChangeHandler: function (event) {
      this.skip = event;
      alert(this.skip)
      this.getDetails();

    },

    closed() {
      this.showAll = false
      this.$router.push('Account')

    },

    sendRequest() {
      Request_se.save(this.text, this.model.unit.id, this.model.user.id).then(response => {
        if (response && response.status === 200) {
          this.text = ""
          this.$snack({type: 'success'})
        }
      })
    },

  },


}
</script>
<style>
.fixed-header-table {
  display: block;
}

.fixed-header-table thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.fixed-header-table tbody {
  display: block;
  max-height: 450px; /* ارتفاع دلخواه */
  overflow-y: auto;
  width: 100%;
}

.fixed-header-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}


</style>

